import { render, staticRenderFns } from "./PaymentSettings.vue?vue&type=template&id=69ac4c66&"
import script from "./PaymentSettings.vue?vue&type=script&lang=js&"
export * from "./PaymentSettings.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/contactum-new/contactum-new/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('69ac4c66')) {
      api.createRecord('69ac4c66', component.options)
    } else {
      api.reload('69ac4c66', component.options)
    }
    module.hot.accept("./PaymentSettings.vue?vue&type=template&id=69ac4c66&", function () {
      api.rerender('69ac4c66', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/admin/components/settings/PaymentSettings.vue"
export default component.exports